//Tracks connected device
import UAParser from 'ua-parser-js'
import * as Cookies from 'tiny-cookie'
import $config from '@/config'
import axios from 'axios';
import eventLog from '@/api/eventLog'

export default {
  actions:{
    async getDeviceInfo(context){
      const parser = new UAParser();
      const result = parser.getResult();
      const info = {
        browser: result.browser.name + ' ' + result.browser.major,
        type: result.device.type,
        os: result.os.name + ' ' + result.os.version
      }

      if(!info.type){
        info['type'] = 'Desktop or others';
      }

      return await axios.get($config.feathersServer+'/geoip').then((resp)=>{
        info['ip'] = resp.data.ip;
        info['city'] = resp.data.city;
        info['country'] = resp.data.country;
        eventLog('checkDevice', context, info);
        return info;
      });
    },
    initDevice(context){
      let device = context.rootGetters['devices/getCopy'];

      if(device){
        return device;
      }

      let cookieName =  'lvcstdvc';
      if(Cookies.get(cookieName)){
        return this.dispatch('devices/get', Cookies.get(cookieName)).then((device)=>{
          return this.dispatch('devices/getDeviceInfo').then((info)=>{
            return this.dispatch('devices/patch', [device._id, info]).then((device)=>{
              context.commit("setCurrent", device._id);
              return device;
            });
          });
        });
      } else {
        return this.dispatch('devices/getDeviceInfo').then((info)=>{
          return this.dispatch('devices/create', info).then((device)=>{
            Cookies.set(cookieName, device._id);
            context.commit("setCurrent", device._id);
            return device;
          })
        });
      }
    }
  }
}